<template>
  <div>
    <b-row align-h="center" class="mb-2">
      <div id="pa-dimensions">
        <div class="diagram-container">
          <img :src="dimensionsImg" alt="dimensions-img" class="d-none d-md-block">
          <img :src="dimensionsImgLabeled" alt="dimensions-img-labeled" class="d-block d-md-none">

          <div class="input door-closer">
            <p class="label">¿Cierra puertas?</p>
            <p class="mb-0 mx-2 d-none d-md-block fs-15" style="font-weight: 500;">¿Lleva brazo cierra puertas?</p>
            <b-radio-group
              v-model="detailsForm.door_closer"
              id="radio-btn"
              size="lg"
              :class="{ 'text-danger': detailsForm.door_closer == null }"
            >
              <b-radio :value="true">Si</b-radio>
              <b-radio :value="false">No</b-radio>
            </b-radio-group>
          </div>

          <div class="input entry-device-1">
            <ValidationProvider rules="required" name="Dispositivo de entrada" style="width: 100%" v-slot="{ valid, errors }">
              <div class="label text-center">
                <p class="mb-0">Dispositivo de</p>
                <p class="mb-0">entrada</p>
              </div>
              <b-select
                v-model="detailsForm.entry_device_1"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="communicationDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input main-lock">
            <ValidationProvider rules="required" name="Cerradura principal" style="width: 100%" v-slot="{ valid, errors }">
              <div class="label text-center">
                <p class="mb-0">Apertura mecánica</p>
                <p class="mb-0">/eléctrica</p>
              </div>
              <b-select
                v-model="detailsForm.main_lock"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="cerraduraPrincipalOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input alerts">
            <ValidationProvider rules="required" name="Alertas" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Alertas</p>
              <b-select
                v-model="detailsForm.alerts"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="alertsOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input lock-type">
            <ValidationProvider rules="required" name="Cerradura" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Cerradura</p>
              <b-select
                v-model="detailsForm.lock_type"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="cerraduraOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input mounting-type">
            <ValidationProvider rules="required" name="Tipo de montaje" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Tipo de montaje</p>
              <b-select
                v-model="detailsForm.mounting_type"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="tipoMontajeOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input exit-device-1">
            <ValidationProvider rules="required" name="Dispositivo de emergencia" style="width: 100%" v-slot="{ valid, errors }">
              <div class="label text-center">
                <p class="mb-0">Dispositivo de</p>
                <p class="mb-0">emergencia</p>
              </div>
              <b-select
                v-model="detailsForm.exit_device_1"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="emergencyDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input exit-device-2">
            <ValidationProvider rules="required" name="Dispositivo de salida" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Dispositivo de salida</p>
              <b-select
                v-model="detailsForm.exit_device_2"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="exitDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>
    </b-row>

    <!-- dimensions sm inputs -->
    <div class="d-block d-md-none">
      <b-row class="flex-column ">
        <Label
          label="¿Lleva brazo cierra puertas?"
          :blank="detailsForm.door_closer === null ? null : 'true'"
          :show-reset="detailsForm.door_closer == true || detailsForm.door_closer == false"
          @reset="detailsForm.door_closer = null"
        />
        <b-form-group>
          <b-radio-group size="lg" v-model="detailsForm.door_closer" class="ml-4">
            <b-radio :value="true">Si</b-radio>
            <b-radio :value="false">No</b-radio>
          </b-radio-group>
        </b-form-group>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Dispositivo de entrada" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de entrada" :blank="detailsForm.entry_device_1" show-reset @reset="detailsForm.entry_device_1 = null" />
            </template>
            <b-select
              v-model="detailsForm.entry_device_1"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="communicationDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Apertura mecánica/eléctrica" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Apertura mecánica/eléctrica" :blank="detailsForm.main_lock" show-reset @reset="detailsForm.main_lock = null" />
            </template>
            <b-select
              v-model="detailsForm.main_lock"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="cerraduraPrincipalOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Alertas" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Alertas" :blank="detailsForm.alerts" show-reset @reset="detailsForm.alerts = null" />
            </template>
            <b-select
              v-model="detailsForm.alerts"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="alertsOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Cerradura" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Cerradura" :blank="detailsForm.lock_type" show-reset @reset="detailsForm.lock_type = null" />
            </template>
            <b-select
              v-model="detailsForm.lock_type"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="cerraduraOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Tipo de montaje" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Tipo de montaje" :blank="detailsForm.mounting_type" show-reset @reset="detailsForm.mounting_type = null" />
            </template>
            <b-select
              v-model="detailsForm.mounting_type"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="tipoMontajeOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Dispositivo de emergencia" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de emergencia" :blank="detailsForm.exit_device_1" show-reset @reset="detailsForm.exit_device_1 = null" />
            </template>
            <b-select
              v-model="detailsForm.exit_device_1"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="emergencyDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Dispositivo de salida" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de salida " :blank="detailsForm.exit_device_2" show-reset @reset="detailsForm.exit_device_2 = null" />
            </template>
            <b-select
              v-model="detailsForm.exit_device_2"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="exitDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider } from 'vee-validate'

import Label from '../../Label'
import Button from '../../../../shared/Button'

import {
  entryExitDevicesOptions,
  communicationDevicesOptions,
  alertsOptions,
  tipoMontajeOptions,
  cerraduraOptions,
  cerraduraPrincipalOptions,
  emergencyDevicesOptions
} from '../../../../../sharedOptions/controlesAccesoModule'

export default {
  name: 'PeatonalManual',
  components: {
    Label,
    Button,
    ValidationProvider
  },
  props: {
    form: Object,
    detailsForm: Object
  },
  data () {
    return {
      dimensionsImg: require('../../../../../../assets/images/control_acceso/peatonal_manual.png'),
      dimensionsImgLabeled: require('../../../../../../assets/images/control_acceso/peatonal_manual_labeled.png'),
      entryExitDevicesOptions: entryExitDevicesOptions,
      tipoMontajeOptions: tipoMontajeOptions,
      cerraduraPrincipalOptions: cerraduraPrincipalOptions,
      cerraduraOptions: cerraduraOptions,
      emergencyDevicesOptions: emergencyDevicesOptions,
      alertsOptions: alertsOptions
    }
  },
  computed: {
    ...mapState({
      controlAcceso: state => state.configurator.configurable,
      submital: state => state.configurator.submital
    }),
    communicationDevicesOptions() {
      return communicationDevicesOptions.filter(option => option.value !== 'Botón de salida')
    },
    exitDevicesOptions () {
      return [
        { value: null, text: '---Seleccionar---' },
        { value: 'Lector de tarjetas', text: 'Lector de tarjetas' },
        { value: 'Lector QR', text: 'Lector QR' },
        { value: 'Teclado numérico', text: 'Teclado numérico' },
        { value: 'Lector biométrico', text: 'Lector biométrico' },
        { value: 'intercomunicador', text: 'intercomunicador' },
        { value: 'Botón de salida', text: 'Botón de salida' },
        { value: 'Sensor de movimiento REX', text: 'Sensor de movimiento REX' },
        { value: 'N/A', text: 'N/A' }
      ]
    }
  }
}
</script>


<style scoped lang="scss">
  #pa-dimensions {
    display: block;
    justify-content: center;
    align-items: center;
    width: 100%;

    .diagram-container {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 100%;
      max-width: 62.5rem;

      img {
        width: 100%;
        height: auto;
        align-self: center;
      }
    }

    .input {
      position: absolute;
      z-index: 10;
      min-width: 180px;
      display: flex;
      flex-direction: column;
      gap: 2px;
      background: rgba(255, 255, 255, 0.94);
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 6px;
      .label {
        display: none;
        font-size: 11px;
        font-weight: 600;
        margin-bottom: 0;
        color: #666;
        text-transform: uppercase;
        letter-spacing: 0.3px;
        line-height: 1.2;
      }
    }
    // inputs
    .door-closer {
      top: 17%;
      left: 11%;
      text-align: center;
    }
    .entry-device-1 {
      top: 40%;
      left: -1%;
    }
    .main-lock {
      bottom: 24%;
      left: 4%;
    }
    .alerts {
      top: 13%;
      right: 4%;
    }
    .lock-type {
    top: 25%;
    right: -1%;
    }
    .mounting-type {
      top: 34%;
      right: -2%;
    }
    .exit-device-1 {
      top: 47%;
      right: -11%;
    }
    .exit-device-2 {
      bottom: 17%;
      right: 1%;
    }
  }

  @media (max-width: 768px) {
    #pa-dimensions {
      .input {
        min-width: 0;
        width: auto;
        padding: 0px;
        border: none;
        // background: transparent;
        background: rgba(255, 255, 255, 0.94);
        box-shadow: none;

        #radio-btn {
          display: none;
        }
        select {
          display: none
        }

        .label {
          font-size: 7px;
          font-weight: 600;
          color: #333;
          white-space: nowrap;
          letter-spacing: normal;
          margin: 0;
        }

        &:hover {
          border: none;
          transform: none;
        }
      }

      // inputs
      .door-closer {
        top: 18%;
        left: 11%;
        text-align: center;
      }
      .entry-device-1 {
        top: 40%;
        left: -1%;
      }
      .main-lock {
        bottom: 24%;
        left: 4%;
      }
      .alerts {
        top: 14%;
        right: 13%;
      }
      .lock-type {
        top: 26.5%;
        right: 6%;
      }
      .mounting-type {
        top: 34.5%;
        right: 1%;
      }
      .exit-device-1 {
        top: 47%;
        right: 3%;
      }
      .exit-device-2 {
        bottom: 18%;
        right: 1%;
      }
    }
  }
</style>
